import React from 'react';
import { Link } from 'react-router-dom';

function link_1() {
  return <a href="http://www.scholarpedia.org/article/Echo_state_network" target="_blank" rel="noopener noreferrer" style={{ color: '#fff' }}>1</a>
}
function link_2() {
  return <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2924583/" target="_blank" rel="noopener noreferrer" style={{ color: '#fff' }}>2</a>
}
function link_3() {
  return <a href="https://arxiv.org/abs/2007.09309" target="_blank" rel="noopener noreferrer" style={{ color: '#fff' }}>3</a>
}
function link_4() {
  return <a href="http://www.scholarpedia.org/article/Mackey-Glass_equation" target="_blank" rel="noopener noreferrer" style={{ color: '#fff' }}>4</a>
}

function SideBar() {
  return (
    <div className="w-100 h-100 px-2 bg-primary text-light">
      <div className="row">
        <div className="w-100 px-4 d-flex flex-row-reverse">
          <Link to="/Report">
            <button className="btn btn-primary" style={{ borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px' }}>Report</button>
          </Link>
          <Link to="/Board">
            <button className="btn btn-primary active" style={{ borderTopRightRadius: '0px', borderBottomRightRadius: '0px' }}>Board</button>
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="px-4 pb-4">
            <h1 className="display" style={{ fontSize: '2em' }}>Abstract</h1>
            <p>
              The dynamics of physiological systems are significantly impacted by delay.
              The time-delay caused by the transport and processing of chemical components and signals may be of significant consequence.
              Biological systems present a challenge to model, analyze and predict.
            </p>
            <p>
              The utilization of machine learning to build mathematical models of complex systems has rapidly grown.
              For time-dependent series, generally a <strong>recurrent neural network</strong> (RNN), capable of returning past states, is used.
              In most common RNN implementations, multiple hidden layers are rebalanced during training to achieve adequate results.
              However, these implementations can be computationally expensive and may require extensive training data.
            </p>
            <p>
              Here, we utilize a type of RNN called an <strong>echo state network</strong><sup>[{ link_1() }]</sup> (ESN), a static, randomly initialized reservoir of nodes.
              We study two types of physiological systems exhibiting delay: <strong>degrade-and-fire</strong><sup>[{link_2()}]</sup> circuits and the <strong>insulin-glucose</strong><sup>[{ link_3() }]</sup> cycle.
              Manipulating only signal propagation and input smoothing, we model both systems with generated reservoirs.
            </p>
            <p>
              In future works, we will further tune the reservoir, addressing stability and noise. We will also research the use of other machine learning techniques in determining the optimal parameters for reservoir generation.
            </p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-sm-6 col-lg-12">
          <div className="p-4">
            <h1 className="display" style={{ fontSize: '1.5em' }}>Source Code</h1>
            <p>
              <a href="https://github.com/minbin/esn" target="_blank" rel="noopener noreferrer" style={{ color: '#fff' }}>https://github.com/minbin/esn</a>
            </p>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-lg-12">
          <div className="p-4">
            <h1 className="display" style={{ fontSize: '1.5em' }}>Interactive Data</h1>
            <p>
              <a href="https://minbin.github.io/uh-surf" target="_blank" rel="noopener noreferrer" style={{ color: '#fff' }}>https://minbin.github.io/uh-surf</a>
            </p>
          </div>
        </div>
        <div className="col-12">
          <div className="p-4">
            <h1 className="display" style={{ fontSize: '1.5em' }}>References</h1>
            <div style={{ fontSize: '0.7em' }}>
              <p>
                [{ link_1() }] <a href="http://www.scholarpedia.org/article/Echo_state_network" target="_blank" rel="noopener noreferrer" style={{ color: '#fff' }}>Echo State Network</a> dx.doi.org/10.4249/scholarpedia.2330
              </p>
              <p>
                [{ link_2() }]
                W. Mather et al., <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2924583/" target="_blank" rel="noopener noreferrer" style={{ color: '#fff' }}>"Delay-Induced Degrade-and-Fire Oscillations in Small Genetic Circuits"</a> doi:10.1103/PhysRevLett.102.068105
              </p>
              <p>
                [{ link_3() }]
                B. Karamched et al., <a href="https://arxiv.org/abs/2007.09309" target="_blank" rel="noopener noreferrer" style={{ color: '#fff' }}>"Delay-induced Uncertainty in Physiological Systems"</a> arXiv:2007.09309
              </p>
              <p>
                [{ link_4() }] <a href="http://www.scholarpedia.org/article/Mackey-Glass_equation" target="_blank" rel="noopener noreferrer" style={{ color: '#fff' }}>Mackey-Glass Equation</a> doi:10.4249/scholarpedia.6908
              </p>
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="p-4">
            <h1 className="display" style={{ fontSize: '1.5em' }}>Acknowledgments</h1>
            <p>
              <small>This research project was funded by the UH Office of Undergraduate Research.</small>
            </p>
            <p>
              <small>Thank you Wendy for your guidance and support.</small>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SideBar;
